import { PrismicNextImage } from "@prismicio/next";
import { isFilled } from "@prismicio/client";
import Link from "next/link";

/**
 * @typedef {import("@prismicio/client").Content.LogoSlice} LogoSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<LogoSlice>} LogoProps
 * @type {import("react").FC<LogoProps>}
 */
const Logo = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {isFilled.image(slice.primary.logo) && (
        <Link href="/" className="cursor-pointer">
          <PrismicNextImage
            field={{
              ...slice.primary.logo,
              alt: slice.primary.logo.alt || "Logo de SOY Architecture",
            }}
            className="h-3.5 w-auto"
          />
        </Link>
      )}
    </section>
  );
};

export default Logo;
